import { render, staticRenderFns } from "./CInput.vue?vue&type=template&id=370fbdf4&scoped=true&"
import script from "./CInput.vue?vue&type=script&lang=js&"
export * from "./CInput.vue?vue&type=script&lang=js&"
import style0 from "./CInput.vue?vue&type=style&index=0&id=370fbdf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370fbdf4",
  null
  
)

export default component.exports